import { RootState } from "../../store/store";

export const selectResult = (state: RootState) => state.scheduledJobExecution.result;
export const selectLoading = (state: RootState) => state.scheduledJobExecution.loading;
export const selectError = (state: RootState) => state.scheduledJobExecution.error;
export const selectErrorMessage = (state: RootState) => state.scheduledJobExecution.errorMessage;
